import { slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useMemo, useEffect } from 'react';
import { StyledListItem, PaginationDotsWrapper, StyledUnorderedList } from './styles.js';
import { arrayOfNumbers } from '../util/math.js';
import { Direction } from './types.js';
export { Direction } from './types.js';
import { usePrevious, getDirection, keepInBounds } from './util.js';

var DOT_BOX_WIDTH = 20;
var FilmstripPaginationDots = function FilmstripPaginationDots(_ref) {
  var _ref$currentPageIndex = _ref.currentPageIndex,
      currentPageIndex = _ref$currentPageIndex === void 0 ? 0 : _ref$currentPageIndex,
      _ref$totalPages = _ref.totalPages,
      totalPages = _ref$totalPages === void 0 ? 1 : _ref$totalPages;

  var _a, _b;
  /** How many dots the pager is wide enough to show */


  var visibleDots = 7;
  var hasMultiplePages = totalPages > 1;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      dotScroll = _useState2[0],
      setDotScroll = _useState2[1];

  var previousPageIndex = (_a = usePrevious(currentPageIndex)) !== null && _a !== void 0 ? _a : 0;
  var previousDotScroll = (_b = usePrevious(dotScroll)) !== null && _b !== void 0 ? _b : 0;
  var translate = dotScroll * -DOT_BOX_WIDTH;
  var pageNumbers = useMemo(function () {
    return arrayOfNumbers(totalPages);
  }, [totalPages]);
  useEffect(function () {
    /** How many dots away from the edge the highlighted dot is going to stay */
    var distanceFromEdge = 2;
    /** The difference in pages between the current page and the previous one */

    var pageDelta = currentPageIndex - (previousPageIndex !== null && previousPageIndex !== void 0 ? previousPageIndex : 0);
    /** Which direction we're going */

    var direction = getDirection(pageDelta);
    /** Wall: when we hit this index, we start scrolling forward */

    var forwardWall = visibleDots - distanceFromEdge;
    /** Wall: when we hit this index, we start scrolling backward */

    var backwardWall = distanceFromEdge - 1 + previousDotScroll;
    /** A minimum for dotScroll, and a maximum! */

    var dotScrollBounds = [0, totalPages - visibleDots];
    /** Convenience function for bounding dotScoll values */

    var withinDotScrollBounds = function withinDotScrollBounds(value) {
      return keepInBounds(value, dotScrollBounds);
    };
    /** Should we scroll forward? */


    var shouldScrollForward = direction === Direction.Forward && currentPageIndex >= forwardWall;
    /** Should we scroll backward? */

    var shouldScrollBackward = direction === Direction.Back && currentPageIndex <= backwardWall;
    /** Should we scroll at all? */

    var shouldScroll = shouldScrollForward || shouldScrollBackward;
    if (shouldScroll) setDotScroll(withinDotScrollBounds(previousDotScroll + pageDelta));
  }, [currentPageIndex, totalPages, previousDotScroll, previousPageIndex]);
  var dots = useMemo(function () {
    return pageNumbers.map(function (i) {
      return React__default.createElement(StyledListItem, {
        active: i === currentPageIndex ? true : false,
        activeNeighbor: i === currentPageIndex - 1 || i === currentPageIndex + 1 ? true : false,
        key: "dot-".concat(i)
      });
    });
  }, [currentPageIndex, pageNumbers]);
  return React__default.createElement(PaginationDotsWrapper, {
    "data-test": "pagination-dots"
  }, hasMultiplePages && React__default.createElement(StyledUnorderedList, {
    translate: translate
  }, dots));
};

export { FilmstripPaginationDots };
